import { render, staticRenderFns } from "./live-item.vue?vue&type=template&id=197e2b1c"
import script from "./live-item.vue?vue&type=script&lang=js"
export * from "./live-item.vue?vue&type=script&lang=js"
import style0 from "./live-item.vue?vue&type=style&index=0&id=197e2b1c&prod&slot-scope=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports